import { useLang } from "../context/LangContext";

export const Marquee = () => {
  const { S } = useLang();
  const items = [...S.marquee, ...S.marquee];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden bg-[#0A182E] border-y border-white/10 py-5">
      <div className="marquee-track">
        {items.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-tech text-xs sm:text-sm font-semibold uppercase tracking-[0.3em] text-slate-300 px-8">
              {item}
            </span>
            <span className="w-2 h-2 rotate-45 bg-sky-500 shrink-0" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};
